<template>
    <ob1-popin-modal2
        :id="id"
        aria-labelledby="popin-customer-label"
        :show-close-button="false"
    >
        <div id="popin-customer-label" class="h4">
            {{ title }}
        </div>
        <p v-if="subtitle" class="mb-0 py-0">
            {{ subtitle }}
        </p>
        <div class="text-center">
            <ob1-boutons
                class="mt-2 mb-1"
                :label="buttonLabel"
                :is-button="false"
                is-secondary
                @ob1-boutons-click="redirectToLink"
            />
        </div>
        <template v-if="text && linkLabelHtml && link">
            <ob1-separateur class="my-2" />
            <p>{{ text }}</p>
            <ob1-liens
                :text="linkLabelHtml"
                :href="link"
                is-large
                with-arrow
            />
        </template>
    </ob1-popin-modal2>
</template>

<script>
export default {
    name: "CustomerPopin",
    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        buttonLabel: {
            type: String,
            required: true
        },
        buttonLink: {
            type: String,
            required: true
        },
        linkLabelHtml: {
            type: String,
            default: null
        },
        link: {
            type: String,
            default: null
        },
        intention: {
            type: String,
            default: null
        }
    },
    methods: {
        redirectToLink: function () {
            if (this.intention) {
                //Redirige vers l'url calculée en back en remplaçant la "return_url" par la page courante,
                //c'est-à-dire avec les filtres sélectionnés par le client, avec l'intention passée en paramètre
                let returnUrl = updateUrlWithParam(window.location.href, "intention", this.intention);
                let encodedReturnUrl = encodeURIComponent(returnUrl);
                window.location.href = updateUrlWithParam(this.buttonLink, "return_url", encodedReturnUrl);
            } else {
                window.location.href = this.buttonLink;
            }
        }
    }
}
</script>
